// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.MoveGroupsToSpacePopup__search-e407cf {
  flex-shrink: 0;
  margin: 16px;
}`, "",{"version":3,"sources":["webpack://./src/main/PopupManager/Popups/MoveGroupsToSpacePopup/MoveGroupsToSpacePopup.styles.m.css"],"names":[],"mappings":"AAAA;EACE,cAAA;EACA,YAAA;AACF","sourcesContent":[".search {\n  flex-shrink: 0;\n  margin: 16px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"search": `MoveGroupsToSpacePopup__search-e407cf`
};
module.exports = ___CSS_LOADER_EXPORT___;
